import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Alert, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useFirebase } from '../../context/FirebaseContext';
import { Logo } from '../layout';
import './ForgotPassword.css';
import { getFirebaseErrorMessage } from '../../utils/firebaseErrors';
import logger from '../../utils/logger';
import { analytics } from '../../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const ForgotPassword = () => {
  const { resetPassword } = useFirebase();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    logEvent(analytics, 'password_reset_attempt', {});

    try {
      setError('');
      setMessage('');
      setLoading(true);
      await resetPassword(email);
      logEvent(analytics, 'password_reset_success', {});
      setMessage('Check your email for password reset instructions');
    } catch (err) {
      logger.error('Password reset error:', err);
      logEvent(analytics, 'password_reset_failed', { error_code: err.code });
      setError(getFirebaseErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="ntb-copilot-forgot-password-container">
      <Box className="ntb-copilot-forgot-password-card">
        <Box className="ntb-copilot-forgot-password-header">
          <Logo />
          <Typography variant="h4" component="h1">
            Reset Password
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Enter your email to receive reset instructions
          </Typography>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}

        <form onSubmit={handleSubmit} className="ntb-copilot-forgot-password-form">
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            variant="outlined"
            required
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            className="ntb-copilot-reset-btn"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </Button>

          <Box className="ntb-copilot-back-to-login">
            <Typography variant="body2">
              Remember your password? <Link component={RouterLink} to="/login">Sign in</Link>
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ mt: 1, textAlign: 'center', color: 'text.secondary' }}>
            Need additional help? Contact us at support@nanotradingcopilot.com
          </Typography>
        </form>
      </Box>
    </Box>
  );
};

export default ForgotPassword; 